var _desc, _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWbcPortalSimpleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 320,
    viewBox: "0 0 1200 320",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "WBC Portal Logo - Cloud and Health Pulse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Blue rounded-square icon with white cloud and pulse line, followed by WBC Portal wordmark.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wbcBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0797FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006BFF"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 240,
    height: 240,
    rx: 42,
    fill: "url(#wbcBlue)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 192              C86 192 72 178 72 158              C72 139 87 124 107 124              C113 93 139 72 172 72              C209 72 237 99 240 136              C263 136 278 153 278 174              C278 187 269 196 256 196              L205 196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 192 L153 192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 192 L171 126 L194 230 L210 196 L256 196"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 800,
    fontSize: 118
  }, /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 205,
    fill: "#061B49"
  }, "WBC"), /*#__PURE__*/React.createElement("text", {
    x: 642,
    y: 205,
    fill: "#0787F5"
  }, "Portal"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbcPortalSimpleLogo);
export default __webpack_public_path__ + "static/media/wbc_portal_simple_logo.5aa600f8e0ab029317a3413e64b3786b.svg";
export { ForwardRef as ReactComponent };